export default __webpack_public_path__ + "static/media/logoagendamiento.2be09229.svg";